 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVERIMAGE from '@/components/CoverImage'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC1 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC1'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC3 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC3'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC4 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC4'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC5 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC5'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC6 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC6'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC7 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC7'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC8 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC8'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC9 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC9'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC10 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC10'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC11 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC11'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC12 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC12'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC13 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC13'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC14 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC14'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC15 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC15'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC16 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC16'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC17 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC17'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC18 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC18'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC19 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC19'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC20 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC20'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC21 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC21'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC22 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC22'
 import MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC23 from '@/components/Mouw_Called_to_the_Life_of_the_Mind_text_CC23'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/CoverImage",
 			"name" : "CoverImage",
 			"component" : COVERIMAGE
 		},
 		{
 			"path" : "/Mouw_Called_to_the_Life_of_the_Mind_text_CC",
 			"name" : "Mouw_Called_to_the_Life_of_the_Mind_text_CC",
 			"component" : MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC
 		},
 		{
 			"path" : "/Mouw_Called_to_the_Life_of_the_Mind_text_CC1",
 			"name" : "Mouw_Called_to_the_Life_of_the_Mind_text_CC1",
 			"component" : MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC1
 		},
 		{
 			"path" : "/Mouw_Called_to_the_Life_of_the_Mind_text_CC3",
 			"name" : "Mouw_Called_to_the_Life_of_the_Mind_text_CC3",
 			"component" : MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC3
 		},
 		{
 			"path" : "/Mouw_Called_to_the_Life_of_the_Mind_text_CC4",
 			"name" : "Mouw_Called_to_the_Life_of_the_Mind_text_CC4",
 			"component" : MOUW_CALLED_TO_THE_LIFE_OF_THE_MIND_TEXT_CC4
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js